import { lazy as reactLazy } from "react";

const CHUNK_RELOAD_KEY = "chunk-reload";

// A deploy replaces the build, so an open tab's route chunks no longer exist on the
// server; reload once to pick up the new build instead of hanging until a hard refresh
const lazy = (importer) =>
  reactLazy(() =>
    importer().then(
      (module) => {
        sessionStorage.removeItem(CHUNK_RELOAD_KEY);
        return module;
      },
      (error) => {
        if (sessionStorage.getItem(CHUNK_RELOAD_KEY)) throw error;
        sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
        window.location.reload();
        return new Promise(() => {});
      }
    )
  );

const routes = [
  {
    name: "login",
    path: "/",
    component: lazy(() => import("../modules/Login")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "signin",
    path: "/signin",
    component: lazy(() => import("../modules/Login")),
    exact: true,
    wrapRoute: "AuthRoute",
    layout: "AuthLayout",
  },
  {
    name: "message",
    path: `/elsnertech/message/:userId`,
    component: lazy(() => import("../modules/Message")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "channel",
    path: `/elsnertech/channels/:channelId`,
    component: lazy(() => import("../modules/Channel")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "thread",
    path: `/elsnertech/unread/threads`,
    component: lazy(() => import("../modules/Thread")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "draft",
    path: `/elsnertech/draft`,
    component: lazy(() => import("../modules/Draft")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "notifications",
    path: `/elsnertech/notifications/:channelId`,
    component: lazy(() => import("../modules/NotificationAlerts")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },
  {
    name: "apiLogs",
    path: `/elsnertech/api-logs`,
    component: lazy(() => import("../modules/ApiLogs")),
    exact: true,
    wrapRoute: "ProtectedRoute",
    layout: "MainLayout",
  },

];

export default routes;
